export default {
  text_one: 'Gagnez {{count}} point',
  text_other: 'Gagnez {{count}} points',
};
